import { createRouter, createWebHistory } from "vue-router";
import { useConfigStore } from "@/stores/useConfigStore";

// Import các component trực tiếp (loại bỏ lazyLoad)
import Login from "../views/auth/Login.vue";
import Register from "../views/auth/Register.vue";
import ForgotPassword from "../views/auth/ForgotPassword.vue";
import ResetPassword from "../views/auth/ResetPassword.vue";
import VerifyEmail from "../views/auth/VerifyEmail.vue";
import Dashboard from "../views/Index.vue";
import UserIndex from "../views/user/Index.vue";
import UserProfileIndex from "../views/user/profile/Index.vue";
import TempResidenceDecl from "../views/user/profile/TempResidenceDecl.vue";
import EditPassword from "../views/user/profile/EditPassword.vue";
import Hotline from "../views/user/about/Hotline.vue";
import TermsOfUse from "../views/user/about/TermsOfUse.vue";
import PrivacyPolicy from "../views/user/about/PrivacyPolicy.vue";
import Error403 from "../views/error/403.vue";
import Error404 from "../views/error/404.vue";
import Mailbox from "../views/mailbox/Index.vue";
import FeedbackIndex from "../views/feedback/Index.vue";
import FeedbackShow from "../views/feedback/Show.vue";
import Invoice from "../views/invoice/Index.vue";
import Preview from "../views/invoice/Preview.vue";

// Cấu hình router
const router = createRouter({
    history: createWebHistory(),
    routes: [
        // Authentication routes
        { path: "/login", name: "login", meta: { requiresAuth: false, layout: "auth" }, component: Login },
        { path: "/preview/:id", name: "preview", meta: { requiresAuth: false, layout: "auth" }, component: Preview },
        { path: "/preview", name: "preview-new", meta: { requiresAuth: false, layout: "auth" }, component: Preview },
        { path: "/register", name: "register", meta: { requiresAuth: false, layout: "auth" }, component: Register },
        { path: "/forgot-password", name: "forgot-password", meta: { requiresAuth: false, layout: "auth" }, component: ForgotPassword },
        { path: "/reset-password", name: "reset-password", meta: { requiresAuth: false, layout: "auth" }, component: ResetPassword },
        { path: "/verify-email", name: "verify-email", meta: { requiresAuth: false, layout: "auth" }, component: VerifyEmail },
        // Dashboard routes
        { path: "/", name: "dashboard", meta: { requiresAuth: true, nav: true, text: "Hợp đồng" }, component: Dashboard },
        // User routes
        { path: "/user", name: "user", meta: { requiresAuth: true, nav: true, text: "Tùy chọn" }, component: UserIndex },
        { path: "/user/profile/index", name: "user-profile-index", meta: { requiresAuth: true, nav: false, text: "Thông tin cá nhân" }, component: UserProfileIndex },
        { path: "/user/profile/temporary-residence-declaration", name: "user-profile-temp_residence_decl", meta: { requiresAuth: true, nav: false, text: "Kê khai tạm trú" }, component: TempResidenceDecl },
        { path: "/user/profile/edit-password", name: "user-profile-edit_password", meta: { requiresAuth: true, nav: false, text: "Cập nhật mật khẩu" }, component: EditPassword },
        { path: "/user/about/hotline", name: "user-about-hotline", meta: { requiresAuth: true, nav: false, text: "Hotline" }, component: Hotline },
        { path: "/user/about/terms_of_use", name: "user-about-terms_of_use", meta: { requiresAuth: true, nav: false, text: "Điều khoản sử dụng" }, component: TermsOfUse },
        { path: "/user/about/privacy-policy", name: "user-about-privacy_policy", meta: { requiresAuth: true, nav: false, text: "Chính sách bảo mật" }, component: PrivacyPolicy },
        { path: "/error-403", name: "403", meta: { requiresAuth: false }, component: Error403 },
        { path: "/error-404", name: "404", meta: { requiresAuth: false }, component: Error404 },
        { path: "/mailbox", name: "mailbox", meta: { requiresAuth: true, nav: true, text: "Hộp thư" }, component: Mailbox },
        // Feedback routes
        { path: "/feedback", name: "feedback", meta: { requiresAuth: true, nav: true, text: "Phản ánh" }, component: FeedbackIndex },
        { path: "/feedback/:id/show", name: "feedback-show", meta: { requiresAuth: true, nav: true, text: "Chi tiết phản ánh" }, component: FeedbackShow },
        { path: "/invoice", name: "invoice", meta: { requiresAuth: true, nav: false, text: "Hóa đơn" }, component: Invoice },
    ],
});

// Cập nhật title dựa trên meta.text của route
router.afterEach((to) => {
    const pageTitle = to.meta.text || "An Resident";
    document.title = pageTitle;
});

// Navigation guard để kiểm tra xác thực
let isUserLoaded = false; // Biến trạng thái để kiểm soát việc tải dữ liệu chỉ một lần

router.beforeEach((to, from, next) => {
    const isAuthenticated = !!localStorage.getItem("token");
    const useConfig = useConfigStore();

    // Nếu không phải public route, kiểm tra xác thực và load user data
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        if (isAuthenticated) {
            if (!isUserLoaded) {
                useConfig.fetchUser();
                isUserLoaded = true;
            }
        } else {
            return next({ name: "login" });
        }
    } else {
        const routeName = to.name;
        
        if(routeName == 'preview' || routeName == 'preview-new'){
            next();
        }
       
        if (isAuthenticated) {
            return next({ name: "dashboard" });
        }
    }
    next();
});

export default router;
